import React, { useEffect, useState } from "react";
// @ts-ignore
import "./SocialShare.css";

const SITE_URL = "https://www.gslimoelite.com/";
const SHARE_TITLE = "GS Limo Elite | Luxury Transportation in NJ, PA and NY";

interface ShareTarget {
  name: string;
  icon: string;
  build: (url: string, title: string) => string;
}

const targets: ShareTarget[] = [
  {
    name: "WhatsApp",
    icon: "fab fa-whatsapp",
    build: (url, title) =>
      `https://api.whatsapp.com/send?text=${encodeURIComponent(`${title} ${url}`)}`,
  },
];

export default function SocialShare(): JSX.Element {
  // Deterministic default keeps prerendered markup and first hydration render
  // identical; the live URL is swapped in after mount for client navigation.
  const [url, setUrl] = useState<string>(SITE_URL);

  useEffect(() => {
    setUrl(window.location.href);
  }, []);

  return (
    <>
      {targets.map((t) => (
        <a
          key={t.name}
          href={t.build(url, SHARE_TITLE)}
          target="_blank"
          rel="noopener noreferrer"
          className="social-btn social-share-btn"
          aria-label={`Share this page on ${t.name}`}
          title={`Share this page on ${t.name}`}
        >
          <i className={t.icon} aria-hidden="true"></i>
        </a>
      ))}
    </>
  );
}
